import { isWeb, useGetListCountriesQuery } from "@stepapp/core";

import React from "react";
import { useWindowDimensions } from "react-native";
import { useBreakpoints } from "../hooks/useBreakpoints";
import Block from "./Block";
import Button from "./Button";
import LinePlaceholder from "./LinePlaceholder";

type Props = {
  countryCode: string;
  onPress: (countryCode: string) => void;
};

const CountrySelector = ({ countryCode: currentCountryCode, onPress }: Props) => {
  const { md } = useBreakpoints();
  const { width: screenWidth } = useWindowDimensions();
  const { data: supportedCountries, loading } = useGetListCountriesQuery();

  const width = md ? 67.5 : (screenWidth - 40) / 8;

  const showLoader = loading && !supportedCountries;

  return (
    <Block>
      {showLoader && (
        <LinePlaceholder
          borderRadius={2.5}
          height={6}
          width={width}
          marginVertical={isWeb ? 1 : 0}
        />
      )}

      {supportedCountries?.listCountries?.map(({ name, id, countryCode }) => (
        <Block key={id} marginVertical={isWeb ? 1 : 0}>
          <Button
            label={name || ""}
            onPress={() => onPress(countryCode)}
            type="secondary"
            labelType={countryCode === currentCountryCode ? "primaryLink" : "primary"}
          />
        </Block>
      ))}
    </Block>
  );
};

export default React.memo(CountrySelector);
